import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Box, Flex, Button, Image, Avatar, Text, useColorMode, Stack, Grid, GridItem, Stat, StatLabel, StatNumber, Icon, useDisclosure, Badge, useColorModeValue, Select, ButtonGroup, Input, IconButton, useToast, Progress, Table, Thead, Tbody, Tr, Th, Td, Tab, TabList, TabPanel, Tabs, TabPanels, InputGroup, InputRightElement, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, VStack, Tfoot, Switch, FormControl, FormLabel, HStack, Card, CardBody, StackDivider, useBreakpointValue } from "@chakra-ui/react";
import { FaPlus, FaEdit, FaTrash, FaArrowLeft, FaUser, FaBullseye, FaEye, FaEyeSlash, FaWalking, FaHeart, FaWeight, FaRulerVertical, FaHeartbeat } from 'react-icons/fa';

import { BiBarChart, BiLineChart } from 'react-icons/bi';
import Logo from "../fitness.png";
import Loading from "./Loader";
import GaugeChart from 'react-gauge-chart';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import { Skeleton, SkeletonText } from "@chakra-ui/react";
import id from 'date-fns/locale/id';
registerLocale('id', id);



export default function DashboardMeal() {
  const navigate = useNavigate();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [activePage, setActivePage] = useState('foot');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const componentRef = useRef();
  const { colorMode, toggleColorMode } = useColorMode();

  useEffect(() => {
    const email = localStorage.getItem('userEmail');
    if (!email) navigate('/login');
  }, [navigate]);

  const showToast = (title, status = 'info') => {
    toast({ title, status, duration: 3000, isClosable: true, position: 'top' });
  };

  //...kode DashboardMeal lainnya...

  return (
    <>
      {isLoading? <Loading /> : (
        <Box>
          {/* HEADER */}
    
          {/* SWITCH PAGE */}
          {activePage === 'foot'? (
            //...grid tombol dashboard
            
        
            <MasterDataFood onBack={() => setActivePage('dashboard')} showToast={showToast} />
           ) : activePage === 'foot'? (
          <MasterDataUser onBack={() => setActivePage('dashboard')} showToast={showToast} />
           ) : (
            <Box p={6}>
              <Button leftIcon={<FaArrowLeft />} onClick={() => setActivePage('dashboard')} mb={4}>Kembali</Button>
              <Text>Halaman {activePage}</Text>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
//------------------------------------------------------------------------
// === COMPONENT MASTER FOOD === TARO DI BAWAH, LUAR DashboardMeal
const MasterDataFood = ({ onBack, showToast }) => {
  const stickyHeaderRef = useRef(null); // ref buat ukur tinggi
  const [stickyTop, setStickyTop] = useState(0); // simpan tinggi
  const toast = useToast();
  const [allFoods, setAllFoods] = useState([]);
  const [selectedFood, setSelectedFood] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });

  const [search, setSearch] = useState('');
  const [minKalori, setMinKalori] = useState('');
  const [maxKalori, setMaxKalori] = useState('');
  const [filterSource, setFilterSource] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100;

  const [form, setForm] = useState({
    food_name: '', serving_size: 100, kalori: '', protein: '', fat: '', carbs: '',
    serat: '', gula: '', lemak: 0, lemak_jenuh: 0, lemak_tak_jenuh_ganda: 0,
    lemak_tak_jenuh_tunggal: 0, kolesterol: 0, sodium: '', kalium: '', source: 'TKPI2017'
  });

  const totalPages = Math.ceil(allFoods.length / itemsPerPage);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const currentFoods = allFoods.slice(startIdx, endIdx);

  const loadFoods = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/get-foods`, {
        params: { search, minKalori, maxKalori, source: filterSource }
      });
      setAllFoods(res.data.foods || []);
      setCurrentPage(1);
    } catch (err) {
      showToast('Gagal load foods', 'error');
    }
  };

  useEffect(() => { loadFoods(); }, [search, minKalori, maxKalori, filterSource]);
 const updateStickyTop = () => {
      if (stickyHeaderRef.current) {
        setStickyTop(stickyHeaderRef.current.offsetHeight);
      }
    };
    
  const openEdit = (food) => {
    setSelectedFood(food);
    setForm(food);
    onOpen();
  };

  const handleSave = async () => {
    if (!form.food_name) return showToast('Nama makanan wajib', 'warning');
    try {
      if (selectedFood) {
        await axios.post(`${process.env.REACT_APP_API_BASE}/update-food`, { id: selectedFood.id,...form });
        showToast('Food berhasil diupdate', 'success');
      } else {
        await axios.post(`${process.env.REACT_APP_API_BASE}/add-food`, form);
        showToast('Food berhasil ditambah', 'success');
        setIsAddOpen(false);
      }
      onClose();
      setForm({ food_name: '', serving_size: 100, kalori: '', protein: '', fat: '', carbs: '', serat: '', gula: '', lemak: 0, lemak_jenuh: 0, lemak_tak_jenuh_ganda: 0, lemak_tak_jenuh_tunggal: 0, kolesterol: 0, sodium: '', kalium: '', source: 'TKPI2017' });
      loadFoods();
    } catch (err) {
      showToast(err.response?.data?.message || 'Gagal simpan', 'error');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus makanan ini?')) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE}/delete-food?id=${id}`);
      showToast('Food dihapus', 'success');
      loadFoods();
    } catch (err) {
      showToast('Gagal hapus', 'error');
    }
  };

  const Pagination = () => {
  // HAPUS: if (totalPages <= 1) return null;
  
  const pageNumbers = [];
  const maxButtons = 5;
  let startPage = Math.max(1, currentPage - 2);
  let endPage = Math.min(totalPages, startPage + maxButtons - 1);
  if (endPage - startPage < maxButtons - 1) {
    startPage = Math.max(1, endPage - maxButtons + 1);
  }
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  return (
    <Box 
      position="sticky" 
      bottom="0" 
      bg="white" 
      borderTop="1px solid" 
      borderColor="gray.200" 
      p={3} 
      zIndex={3}
      boxShadow="0 -2px 8px rgba(0,0,0,0.08)"
    >
      <Flex justify="space-between" align="center" wrap="wrap" gap={2}>
        <Text fontSize="sm" fontWeight="semibold" color="purple.600">
          Page {currentPage} / {totalPages || 1} | Data {allFoods.length === 0 ? 0 : startIdx + 1}-{Math.min(endIdx, allFoods.length)} dari {allFoods.length}
        </Text>
        
        <ButtonGroup size="sm" isAttached>
          <Button onClick={() => setCurrentPage(1)} isDisabled={currentPage === 1}>First</Button>
          <Button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} isDisabled={currentPage === 1}>Prev</Button>
          
          {totalPages > 1 && pageNumbers.map(num => ( // tombol angka cuma muncul kalau > 1 page
            <Button 
              key={num} 
              colorScheme={currentPage === num? 'purple' : 'gray'} 
              onClick={() => setCurrentPage(num)}
            >
              {num}
            </Button>
          ))}
          
          <Button onClick={() => setCurrentPage(p => Math.min(totalPages || 1, p + 1))} isDisabled={currentPage === totalPages || totalPages <= 1}>Next</Button>
          <Button onClick={() => setCurrentPage(totalPages || 1)} isDisabled={currentPage === totalPages || totalPages <= 1}>Last</Button>
        </ButtonGroup>
      </Flex>
    </Box>
  );
};

  return (
    <Box p={{ base: 2, md: 4 }}>
      
      {/* === STICKY HEADER + FILTER WRAPPER === */}
      <Box
         ref={stickyHeaderRef} // <-- ini kuncinya
      position="sticky" 
      top="0" 
      bg="white" 
      zIndex={3} 
      pb={2} 
      borderBottom="1px solid" 
      borderColor="gray.200" 
      mb={2} >
        {/* Header */}
        <Flex justify="space-between" mb={3} align="center" wrap="wrap" gap={2}>
          <Button leftIcon={<FaArrowLeft />} onClick={onBack} variant="ghost" size="sm">Kembali</Button>
          <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold">Master Data Foods</Text>
          <Button leftIcon={<FaPlus />} colorScheme="green" size="sm" onClick={() => {
            setSelectedFood(null);
            setForm({ food_name: '', serving_size: 100, kalori: '', protein: '', fat: '', carbs: '', serat: '', gula: '', lemak: 0, lemak_jenuh: 0, lemak_tak_jenuh_ganda: 0, lemak_tak_jenuh_tunggal: 0, kolesterol: 0, sodium: '', kalium: '', source: 'TKPI2017' });
            setIsAddOpen(true);
          }}>Tambah Food</Button>
        </Flex>

        {/* Filter + Search - JUGA STICKY */}
        <HStack mb={0} spacing={2} wrap="wrap">
          <Input placeholder="Search nama makanan..." value={search} onChange={e => setSearch(e.target.value)} maxW="250px" size="sm" />
          <Input placeholder="Min Kalori" type="number" value={minKalori} onChange={e => setMinKalori(e.target.value)} maxW="120px" size="sm" />
          <Input placeholder="Max Kalori" type="number" value={maxKalori} onChange={e => setMaxKalori(e.target.value)} maxW="120px" size="sm" />
          <Select value={filterSource} onChange={e => setFilterSource(e.target.value)} maxW="150px" size="sm">
            <option value="">All Source</option>
            <option value="TKPI2017">TKPI2017</option>
            <option value="Custom">Custom</option>
          </Select>
          <Button size="sm" onClick={() => { setSearch(''); setMinKalori(''); setMaxKalori(''); setFilterSource(''); }}>Reset</Button>
        </HStack>
      </Box>

      {/* Tabel Desktop - scroll body, thead sticky lagi di bawah filter */}
{/* Tabel Desktop */}
<Box display={{ base: 'none', md: 'block' }} overflowX="auto" borderWidth="1px" borderRadius="lg" maxH="60vh" overflowY="auto">
  <Table size="sm">
    <Thead 
      bg="gray.50" 
      position="sticky" 
      top={`${stickyTop}px`} // <-- dinamis, auto ngikutin tinggi header+filter
      zIndex={2} 
      boxShadow="0 2px 4px rgba(0,0,0,0.1)"
    >
      <Tr>
        <Th textAlign="center">ID</Th>
        <Th textAlign="center">NAMA</Th>
        <Th textAlign="center">SERVING</Th>
        <Th textAlign="center">KALORI</Th>
        <Th textAlign="center">PROTEIN</Th>
        <Th textAlign="center">CARBS</Th>
        <Th textAlign="center">FAT</Th>
        <Th textAlign="center">SOURCE</Th>
        <Th textAlign="center">AKSI</Th>
      </Tr>
    </Thead>
    <Tbody>
      {currentFoods.map(f => (
        <Tr key={f.id}>
          <Td textAlign="center">{f.id}</Td>
          <Td fontWeight="semibold">{f.food_name}</Td>
          <Td textAlign="center">{f.serving_size}g</Td>
          <Td textAlign="center">{f.kalori} kkal</Td>
          <Td textAlign="center">{f.protein}g</Td>
          <Td textAlign="center">{f.carbs}g</Td>
          <Td textAlign="center">{f.fat}g</Td>
          <Td textAlign="center"><Badge>{f.source}</Badge></Td>
          <Td textAlign="center">
            <HStack spacing={1} justify="center">
              <IconButton icon={<FaEdit />} size="xs" onClick={() => openEdit(f)} />
              <IconButton icon={<FaTrash />} size="xs" colorScheme="red" onClick={() => handleDelete(f.id)} />
            </HStack>
          </Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
</Box>

      {/* Card Mobile - scroll normal */}
      <VStack spacing={3} display={{ base: 'flex', md: 'none' }} align="stretch" maxH="70vh" overflowY="auto" pr={1}>
        {currentFoods.map(f => (
          <Card key={f.id} borderWidth="1px">
            <CardBody p={3}>
              <Flex justify="space-between" mb={2}>
                <Text fontWeight="bold">{f.food_name}</Text>
                <Badge>{f.source}</Badge>
              </Flex>
              <Text fontSize="sm">Kalori: {f.kalori} kkal | Serving: {f.serving_size}g</Text>
              <Text fontSize="xs" color="gray.600">P:{f.protein}g C:{f.carbs}g F:{f.fat}g</Text>
              <HStack mt={2} justify="end">
                <Button size="xs" leftIcon={<FaEdit />} onClick={() => openEdit(f)}>Edit</Button>
                <Button size="xs" leftIcon={<FaTrash />} colorScheme="red" onClick={() => handleDelete(f.id)}>Hapus</Button>
              </HStack>
            </CardBody>
          </Card>
        ))}
      </VStack>

      <Pagination />

      <Modal isOpen={isOpen || isAddOpen} onClose={() => { onClose(); setIsAddOpen(false); }} size={isMobile? 'full' : 'xl'} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selectedFood? 'Edit' : 'Tambah'} Food</ModalHeader>
          <ModalBody overflowY="auto">
            <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={3}>
              <GridItem colSpan={{ base: 1, md: 3 }}>
                <FormLabel>Nama Makanan *</FormLabel>
                <Input value={form.food_name} onChange={e => setForm({...form, food_name: e.target.value})} />
              </GridItem>
              <GridItem><FormLabel>Serving Size g</FormLabel><Input type="number" value={form.serving_size} onChange={e => setForm({...form, serving_size: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Kalori kkal</FormLabel><Input type="number" step="0.01" value={form.kalori} onChange={e => setForm({...form, kalori: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Protein g</FormLabel><Input type="number" step="0.01" value={form.protein} onChange={e => setForm({...form, protein: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Carbs g</FormLabel><Input type="number" step="0.01" value={form.carbs} onChange={e => setForm({...form, carbs: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Fat g</FormLabel><Input type="number" step="0.01" value={form.fat} onChange={e => setForm({...form, fat: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Serat g</FormLabel><Input type="number" step="0.01" value={form.serat} onChange={e => setForm({...form, serat: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Gula g</FormLabel><Input type="number" step="0.01" value={form.gula} onChange={e => setForm({...form, gula: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Sodium mg</FormLabel><Input type="number" step="0.01" value={form.sodium} onChange={e => setForm({...form, sodium: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Kalium mg</FormLabel><Input type="number" step="0.01" value={form.kalium} onChange={e => setForm({...form, kalium: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Lemak Jenuh</FormLabel><Input type="number" step="0.01" value={form.lemak_jenuh} onChange={e => setForm({...form, lemak_jenuh: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Lemak Tak Jenuh Ganda</FormLabel><Input type="number" step="0.01" value={form.lemak_tak_jenuh_ganda} onChange={e => setForm({...form, lemak_tak_jenuh_ganda: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Lemak Tak Jenuh Tunggal</FormLabel><Input type="number" step="0.01" value={form.lemak_tak_jenuh_tunggal} onChange={e => setForm({...form, lemak_tak_jenuh_tunggal: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Kolesterol mg</FormLabel><Input type="number" step="0.01" value={form.kolesterol} onChange={e => setForm({...form, kolesterol: e.target.value})} /></GridItem>
              <GridItem><FormLabel>Source</FormLabel>
                <Select value={form.source} onChange={e => setForm({...form, source: e.target.value})}>
                  <option value="TKPI2017">TKPI2017</option>
                  <option value="Custom">Custom</option>
                </Select>
              </GridItem>
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => { onClose(); setIsAddOpen(false); }} mr={3}>Batal</Button>
            <Button colorScheme="purple" onClick={handleSave}>Simpan</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

//------------------------------------------------------------------------

const MasterDataUser = ({ onBack }) => {
  const toast = useToast();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalType, setModalType] = useState('profile');
  const [form, setForm] = useState({});
  const isMobile = useBreakpointValue({ base: true, md: false });
  // Responsive: true kalau layar HP
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '', email: '', password: '', jenis_kelamin: 'pria', tanggal_lahir: ''
  });
  const [showAddPwd, setShowAddPwd] = useState(false); // <-- pisah

  // State untuk ganti password edit user
  const [pwd, setPwd] = useState({ old: '', new: '', confirm: '' });
  const [pwdError, setPwdError] = useState('');
  const [pwdStrength, setPwdStrength] = useState({ score: 0, label: '', color: 'gray' });
  const [showPwd, setShowPwd] = useState({ old: false, new: false, confirm: false });

  const showToast = (title, status = 'info') => {
    toast({ title, status, duration: 3000, isClosable: true, position: 'top' });
  };

  

  const loadUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/get-users`);
      setUsers(res.data.users || []);
    } catch (err) {
      showToast('Gagal load user: ' + err.message, 'error');
    }
  };



  const openModal = (user, type) => {
    setSelectedUser(user);
    setModalType(type);
    setForm(user);
    setPwd({ old: '', new: '', confirm: '' }); // reset password pas buka modal
    onOpen();
  };


const handleSaveAdd = async () => {
    if (!newUser.name ||!newUser.email ||!newUser.password) {
      return showToast('Nama, Email, Password wajib diisi', 'warning');
    }
    if (newUser.password.length < 6) {
      return showToast('Password minimal 6 karakter', 'warning');
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE}/add-user`, newUser);
      showToast('User berhasil ditambahkan', 'success');
      setIsAddOpen(false);
      setNewUser({ name: '', email: '', password: '', jenis_kelamin: 'pria', tanggal_lahir: '' });
      loadUsers();
    } catch (err) {
      showToast(err.response?.data?.message || 'Gagal tambah user', 'error');
    }
  };
  
  const cekPasswordStrength = (password) => {
    let score = 0;
    if (password.length >= 6) score += 1;
    if (password.length >= 8) score += 1;
    if (/[A-Z]/.test(password)) score += 1;
    if (/[0-9]/.test(password)) score += 1;
    if (/[^A-Za-z0-9]/.test(password)) score += 1;
    const levels = [
      { score: 0, label: '', color: 'gray' },
      { score: 1, label: 'Sangat Lemah', color: 'red' },
      { score: 2, label: 'Lemah', color: 'orange' },
      { score: 3, label: 'Cukup', color: 'yellow' },
      { score: 4, label: 'Kuat', color: 'blue' },
      { score: 5, label: 'Sangat Kuat', color: 'green' }
    ];
    return levels[score];
  };

  const handleSave = async () => {
    if (pwd.new || pwd.confirm || pwd.old) {
      if (!pwd.old) return showToast('Masukkan Old Password', 'warning');
      if (pwd.new.length < 6) return showToast('New Password minimal 6 karakter', 'warning');
      if (pwd.new!== pwd.confirm) return showToast('New Password dan Confirm beda', 'error');
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE}/update-user-profile`, {
        id: selectedUser.id,...form
      });
      if (pwd.new) {
        await axios.post(`${process.env.REACT_APP_API_BASE}/update-user-password`, {
          id: selectedUser.id, old_password: pwd.old, new_password: pwd.new
        });
      }
      showToast('Data berhasil diupdate', 'success');
      setPwd({ old: '', new: '', confirm: '' });
      onClose();
      loadUsers();
    } catch (err) {
      showToast(err.response?.data?.message || 'Gagal simpan', 'error');
    }
  };

  const toggleActive = async (id, is_active) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE}/toggle-user`, { id, is_active: is_active? 0 : 1 });
      loadUsers();
    } catch (err) {
      showToast('Gagal update status', 'error');
    }
  };

  useEffect(() => { loadUsers(); }, []);

  const hitungUmur = (tgl) => {
    if (!tgl) return '-';
    const diff = Date.now() - new Date(tgl).getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  };

  return (
    <Box p={{ base: 2, md: 4 }}>
      <Flex justify="space-between" mb={4} align="center">
        <Button leftIcon={<FaArrowLeft />} onClick={onBack} variant="ghost" size={{ base: 'sm', md: 'md' }}>Kembali</Button>
        <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold">Master Data User</Text>
        <Button leftIcon={<FaPlus />} colorScheme="green" size={{ base: 'sm', md: 'md' }}
          onClick={() => {
            setNewUser({ name: '', email: '', password: '', jenis_kelamin: 'pria', tanggal_lahir: '' });
            setShowAddPwd(false);
            setIsAddOpen(true);
          }}
        >Tambah User</Button>
      </Flex>





   
      <Flex justify="space-between" mb={4} align="center">
        <Button leftIcon={<FaArrowLeft />} onClick={onBack} variant="ghost" size={{ base: 'sm', md: 'md' }}>Kembali</Button>
        <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold">Master Data User</Text>
        <Box w={{ base: '80px', md: '100px' }} />
      </Flex>

      {/* VIEW DESKTOP: TABEL */}
      <Box display={{ base: 'none', md: 'block' }} overflowX="auto" borderWidth="1px" borderRadius="lg">
  
   
   
        <Table size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>ID</Th>
              <Th>Nama</Th>
              <Th>Email</Th>
              <Th>JK</Th>
              <Th>Umur</Th>
              <Th>Target Kkal</Th>
              <Th>Status</Th>
              <Th>Aksi</Th>
            </Tr>
          </Thead>
          <Tbody>
            {users.map(u => (
              <Tr key={u.id}>
                <Td>{u.id}</Td>
                <Td fontWeight="semibold">{u.name}</Td>
                <Td fontSize="sm">{u.email}</Td>
                <Td><Badge colorScheme={u.jenis_kelamin === 'pria'? 'blue' : 'pink'}>{u.jenis_kelamin}</Badge></Td>
                <Td>{hitungUmur(u.tanggal_lahir)} thn</Td>
                <Td>{u.target_kalori} kkal</Td>
                <Td><Switch size="sm" isChecked={u.is_active === 1} onChange={() => toggleActive(u.id, u.is_active)} /></Td>
                <Td>
                  <HStack spacing={1}>
                    <IconButton icon={<FaUser />} size="xs" onClick={() => openModal(u, 'profile')} />
                    <IconButton icon={<FaBullseye />} size="xs" colorScheme="purple" onClick={() => openModal(u, 'target')} />
                  </HStack>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {/* VIEW MOBILE: CARD LIST */}
      <VStack spacing={3} display={{ base: 'flex', md: 'none' }} align="stretch">
        {users.map(u => (
          <Card key={u.id} borderWidth="1px" shadow="sm">
            <CardBody p={3}>
              <VStack align="stretch" divider={<StackDivider borderColor="gray.100" />} spacing={2}>
                <Flex justify="space-between">
                  <Text fontWeight="bold">{u.name}</Text>
                  <Badge colorScheme={u.jenis_kelamin === 'pria'? 'blue' : 'pink'} fontSize="xs">{u.jenis_kelamin}</Badge>
                </Flex>

                <Text fontSize="xs" color="gray.600">{u.email}</Text>

                <HStack justify="space-between" fontSize="sm">
                  <Text>Umur: <b>{hitungUmur(u.tanggal_lahir)} thn</b></Text>
                  <Text>Target: <b>{u.target_kalori} kkal</b></Text>
                </HStack>

                <Flex justify="space-between" align="center" pt={2}>
                  <HStack>
                    <Text fontSize="sm">Aktif</Text>
                    <Switch size="sm" isChecked={u.is_active === 1} onChange={() => toggleActive(u.id, u.is_active)} />
                  </HStack>
                  <HStack>
                    <Button leftIcon={<FaUser />} size="xs" onClick={() => openModal(u, 'profile')}>Profile</Button>
                    <Button leftIcon={<FaBullseye />} size="xs" colorScheme="purple" onClick={() => openModal(u, 'target')}>Target</Button>
                  </HStack>
                </Flex>
              </VStack>
            </CardBody>
          </Card>
        ))}
      </VStack>

      {/* Modal tetap sama, tapi size responsive */}
      <Modal isOpen={isOpen} onClose={onClose} size={isMobile? 'full' : 'xl'}>
        <ModalOverlay />
        <ModalContent borderRadius={isMobile? 0 : 'lg'} h={isMobile? '100vh' : 'auto'}>
          <ModalHeader fontSize={{ base: 'md', md: 'lg' }}>
            {modalType === 'profile'? 'Edit Profile' : 'Edit Target Nutrisi'} - {selectedUser?.name}
          </ModalHeader>
          <ModalBody overflowY="auto">
            {modalType === 'profile'? (
 <VStack spacing={4} align="stretch">
    {/* Data Profile */}
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={4}>
      <GridItem>
        <FormLabel>Nama</FormLabel>
        <Input value={form.name || ''} onChange={e => setForm({...form, name: e.target.value})} />
      </GridItem>
      <GridItem>
        <FormLabel>Email</FormLabel>
        <Input value={form.email || ''} onChange={e => setForm({...form, email: e.target.value})} />
      </GridItem>
      <GridItem>
        <FormLabel>Jenis Kelamin</FormLabel>
        <Select value={form.jenis_kelamin} onChange={e => setForm({...form, jenis_kelamin: e.target.value})}>
          <option value="pria">Pria</option>
          <option value="wanita">Wanita</option>
        </Select>
      </GridItem>
      <GridItem>
        <FormLabel>Tanggal Lahir</FormLabel>
        <Input type="date" value={form.tanggal_lahir?.split('T')[0]} onChange={e => setForm({...form, tanggal_lahir: e.target.value})} />
      </GridItem>

  

        
    </Grid>




    {/* Ganti Password */}
    <Box borderTop="1px solid" borderColor="gray.200" pt={4} mt={2}>
      <Text fontWeight="bold" mb={3}>Ganti Password</Text>

      <VStack spacing={3}>
        <FormControl>
          <FormLabel fontSize="sm">Old Password</FormLabel>
          <Input
            type="password"
            placeholder="Masukkan password lama"
            value={pwd.old}
            onChange={e => setPwd({...pwd, old: e.target.value})}
            onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
          />
        </FormControl>

        <FormControl>
 <FormLabel fontSize="sm">New Password</FormLabel>
  <InputGroup>
    <Input
   
      type={showPwd.new? 'text' : 'password'}
  onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      placeholder="Minimal 6 karakter"
      value={pwd.new}
      onChange={e => {
        const val = e.target.value;
        setPwd({...pwd, new: val});
        setPwdStrength(cekPasswordStrength(val));
        setPwdError('');
        // Cek ulang confirm
        if (pwd.confirm && val!== pwd.confirm) {
          setPwdError('New Password dan Confirm beda');
        } else {
          setPwdError('');
        }
      }}
    />
    <InputRightElement>
      <IconButton
        size="sm"
        variant="ghost"
        icon={showPwd.new? <FaEyeSlash /> : <FaEye />}
        onClick={() => setShowPwd({...showPwd, new:!showPwd.new})}
        aria-label="toggle password"
        onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      />
    </InputRightElement>
  </InputGroup>

  {/* Strength bar */}
  {pwd.new && (
    <Box mt={2}>
      <Progress
        value={pwdStrength.score * 20}
        colorScheme={pwdStrength.color}
        size="sm"
        borderRadius="md"
      />
      <Text fontSize="xs" color={`${pwdStrength.color}.600`} mt={1}>
        {pwdStrength.label}
      </Text>
    </Box>
  )}
        </FormControl>

        <FormControl isInvalid={pwdError!== ''}>
          <FormLabel fontSize="sm">Confirm New Password</FormLabel>
          <Input
            type="password"
            placeholder="Ulangi password baru"
            value={pwd.confirm}
            onChange={e => {
              setPwd({...pwd, confirm: e.target.value});
              if (pwd.new!== e.target.value && e.target.value!== '') {
                setPwdError('New Password dan Confirm beda');
              } else {
                setPwdError('');
              }
            }}
          />
          {pwdError && <Text color="red.500" fontSize="xs" mt={1}>{pwdError}</Text>}
        </FormControl>
      </VStack>
    </Box>
  </VStack>







            ) : (
              <Tabs size={isMobile? 'sm' : 'md'}>
                <TabList>
                  <Tab>Kalori</Tab>
                  <Tab>Makro</Tab>
                  <Tab>Mikro</Tab>
                </TabList>
                <TabPanels>
                  <TabPanel>
                    <FormControl>
                      <FormLabel>Target Kalori</FormLabel>
                      <Input type="number" value={form.target_kalori || 0} onChange={e => setForm({...form, target_kalori: parseInt(e.target.value)})} />
                    </FormControl>
                  </TabPanel>
                  <TabPanel>
                    <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={3}>
                      <Box><FormLabel>Karbo</FormLabel><Input type="number" value={form.target_carbs || 0} onChange={e => setForm({...form, target_carbs: parseInt(e.target.value)})} /></Box>
                      <Box><FormLabel>Protein</FormLabel><Input type="number" value={form.target_protein || 0} onChange={e => setForm({...form, target_protein: parseInt(e.target.value)})} /></Box>
                      <Box><FormLabel>Lemak</FormLabel><Input type="number" value={form.target_fat || 0} onChange={e => setForm({...form, target_fat: parseInt(e.target.value)})} /></Box>
                    </Grid>
                  </TabPanel>
                  <TabPanel>
                    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={3}>
                      <Box><FormLabel>Serat</FormLabel><Input type="number" step="0.1" value={form.target_serat || 0} onChange={e => setForm({...form, target_serat: parseFloat(e.target.value)})} /></Box>
                      <Box><FormLabel>Gula</FormLabel><Input type="number" step="0.1" value={form.target_gula || 0} onChange={e => setForm({...form, target_gula: parseFloat(e.target.value)})} /></Box>
                      <Box><FormLabel>Sodium</FormLabel><Input type="number" step="0.1" value={form.target_sodium || 0} onChange={e => setForm({...form, target_sodium: parseFloat(e.target.value)})} /></Box>
                      <Box><FormLabel>Kalium</FormLabel><Input type="number" step="0.1" value={form.target_kalium || 0} onChange={e => setForm({...form, target_kalium: parseFloat(e.target.value)})} /></Box>
                    </Grid>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            )}
          </ModalBody>


          
    <ModalFooter>
      <Button type="button" onClick={onClose} mr={3} size={{ base: 'sm', md: 'md' }}>Batal</Button>
      <Button type="button" colorScheme="purple" onClick={handleSave} size={{ base: 'sm', md: 'md' }}>Simpan</Button>
    </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpen} onClose={onClose} size={isMobile? 'full' : 'xl'} closeOnOverlayClick={false} closeOnEsc={false}>
        {/*...isi modal edit password pakai showPwd seperti sebelumnya... */}
      </Modal>

      {/* Modal Tambah User - pakai showAddPwd sendiri */}
      <Modal isOpen={isAddOpen} onClose={() => setIsAddOpen(false)} size={isMobile? 'full' : 'md'} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Tambah User Baru</ModalHeader>
          <ModalBody>
            <VStack spacing={3} align="stretch">
              <FormControl isRequired>
                <FormLabel>Nama</FormLabel>
                <Input autoComplete="off" value={newUser.name} onChange={e => setNewUser({...newUser, name: e.target.value})} />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Email</FormLabel>
                <Input autoComplete="off" type="email" value={newUser.email} onChange={e => setNewUser({...newUser, email: e.target.value})} />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Password</FormLabel>
                <InputGroup>
                  <Input autoComplete="new-password" type={showAddPwd? 'text' : 'password'} value={newUser.password}
                    onChange={e => setNewUser({...newUser, password: e.target.value})} />
                  <InputRightElement>
                    <IconButton size="sm" variant="ghost"
                      icon={showAddPwd? <FaEyeSlash /> : <FaEye />}
                      onClick={() => setShowAddPwd(!showAddPwd)} />
                  </InputRightElement>
                </InputGroup>
              </FormControl>

              <FormControl>
                <FormLabel>Jenis Kelamin</FormLabel>
                <Select value={newUser.jenis_kelamin} onChange={e => setNewUser({...newUser, jenis_kelamin: e.target.value})}>
                  <option value="pria">Pria</option>
                  <option value="wanita">Wanita</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Tanggal Lahir</FormLabel>
                <Input type="date" value={newUser.tanggal_lahir} onChange={e => setNewUser({...newUser, tanggal_lahir: e.target.value})} />
              </FormControl>
            </VStack>
      
    </ModalBody>
    <ModalFooter>
      <Button type="button" onClick={() => setIsAddOpen(false)} mr={3}>Batal</Button>
      <Button type="button" colorScheme="green" onClick={handleSaveAdd}>Simpan</Button>
    </ModalFooter>
  </ModalContent>
</Modal>
      
    </Box>

    
  );
};

//-----------------------